import axios from '@/axios'

const API_BASE = `${process.env.VUE_APP_API_BASE_URL}/api/alquileres`
// Adjust endpoints here if your backend uses different paths or query filters
const ENDPOINTS = {
  myRent: `${API_BASE}/contratos/mi-alquiler/`,
}

const state = {
  loading: false,
  error: null,
  contract: null,
  invoices: [],
  payments: [],
  adjustments: [],
  penalties: [],
  projection: null,
}

const mutations = {
  SET_LOADING(state, val) { state.loading = val },
  SET_ERROR(state, err) { state.error = err },
  SET_CONTRACT(state, payload) { state.contract = payload },
  SET_INVOICES(state, payload) { state.invoices = payload || [] },
  SET_PAYMENTS(state, payload) { state.payments = payload || [] },
  SET_ADJUSTMENTS(state, payload) { state.adjustments = payload || [] },
  SET_PENALTIES(state, payload) { state.penalties = payload || [] },
  SET_PROJECTION(state, payload) { state.projection = payload },
}

const actions = {
  async fetchMyRental({ commit }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const { data } = await axios.get(ENDPOINTS.myRent, { withCredentials: true })

      // Mapear directamente según el payload ejemplo del backend
      commit('SET_CONTRACT', {
        id: data.id,
        cliente_email: data.cliente_email,
        cliente_nombre: data.cliente_nombre,
        fecha_inicio: data.fecha_inicio,
        fecha_fin: data.fecha_fin,
        monto_base: data.monto_base,
        moneda: data.moneda,
        dia_vencimiento: data.dia_vencimiento,
        aplicar_mora: data.aplicar_mora,
        porcentaje_mora_mensual: data.porcentaje_mora_mensual,
        esquema_ajuste: data.esquema_ajuste,
        indice_referencia: data.indice_referencia,
        periodicidad_ajuste_meses: data.periodicidad_ajuste_meses,
        estado: data.estado,
        resumen: data.resumen,
        propiedad: data.propiedad,
      })
      commit('SET_INVOICES', data.facturas || [])
      commit('SET_PAYMENTS', data.pagos || [])
      commit('SET_ADJUSTMENTS', data.ajustes || [])
      commit('SET_PENALTIES', data.penalidades || [])
    } catch (err) {
      if (err?.response?.status === 404) {
        // Sin alquiler asignado al usuario: no es un error para la UI.
        commit('SET_CONTRACT', null)
        commit('SET_INVOICES', [])
        commit('SET_PAYMENTS', [])
        commit('SET_ADJUSTMENTS', [])
        commit('SET_PENALTIES', [])
        commit('SET_ERROR', null)
      } else {
        commit('SET_ERROR', err.response?.data || err.message || 'Error cargando datos de alquiler')
      }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // Optional helper actions
  async recalcInvoiceLateFees(_, invoiceId) {
    return axios.post(`${API_BASE}/facturas/${invoiceId}/recalcular-mora/`, {}, { withCredentials: true })
  },
  async confirmPayment(_, paymentId) {
    return axios.post(`${API_BASE}/pagos/${paymentId}/confirmar/`, {}, { withCredentials: true })
  },
  async generateInvoice({ state, dispatch }) {
    if (!state.contract?.id) throw new Error('Contrato no disponible')
    await axios.post(`${API_BASE}/contratos/${state.contract.id}/generar-factura/`, {}, { withCredentials: true })
    await dispatch('fetchMyRental')
  },
  async fetchProjection({ state, commit }) {
    if (!state.contract?.id) throw new Error('Contrato no disponible')
    const { data } = await axios.get(`${API_BASE}/contratos/${state.contract.id}/proyeccion/`, { withCredentials: true })
    commit('SET_PROJECTION', data)
  },
}

const getters = {
  myContract: s => s.contract,
  myInvoices: s => s.invoices,
  myPayments: s => s.payments,
  myAdjustments: s => s.adjustments,
  myPenalties: s => s.penalties,
  myProjection: s => s.projection,
  rentLoading: s => s.loading,
  rentError: s => s.error,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
